export const no = {
  main: {
    color_hex: 'Farge i heksadesimal notasjon, start med #',
    language: 'Norsk',
    restricted_field_name: 'Dette feltnavnet er reservert og kan ikke brukes',
    asset_type_required: 'Velg minst én utstyrstype eller gjør feltet globalt',
    searchbar: 'Søk (min. 3 tegn)',
    title: 'Admin',
    logout: 'Logg ut',
    english: 'Engelsk',
    dutch: 'Nederlandsk',
    french: 'Fransk',
    spanish: 'Spansk',
    danish: 'Dansk',
    italian: 'Italiensk',
    romanian: 'Rumensk',
    norwegian: 'Norsk',
    german: 'Tysk',
    drop_image: 'Slipp bildet ditt her',
  },
  ra: {
    tree: {
      add_child_node: 'Legg til underkategori',
      add_node_after: 'Legg til kategori etter',
      add_node_before: 'Legg til kategori før',
      close: 'Lukk',
      expand: 'Åpne',
    },
  },
  resources: {
    categories: {
      name: 'Kategori |||| Kategorier',
      fields: {
        name: 'Kategorinavn',
      },
    },
    users: {
      name: 'Bruker |||| Brukere',
      fields: {
        category: 'Kategori',
        connection: 'Tilkobling',
        email: 'E-post',
        familyName: 'Etternavn',
        firstName: 'Fornavn',
        language: 'Språk',
        userRoles: 'Roller',
      },
    },
    priorities: {
      name: 'Prioritet |||| Prioriteter',
    },
    branding: {
      name: 'Merkevarebygging',
    },
    invitations: {
      name: 'Invitasjon |||| Invitasjoner',
      fields: {
        email: 'E-post',
      },
    },
    'asset-types': {
      name: 'Utstyrstype |||| Utstyrstyper',
      fields: {
        name: 'Navn',
      },
    },
    'asset-statuses': {
      name: 'Utstyrsstatus |||| Utstyrsstatuser',
      fields: {
        name: 'Navn',
      },
    },
    'asset-custom-fields': {
      name: 'Tilpasset utstyrsfelt |||| Tilpassede utstyrsfelt',
      fields: {
        name: 'Navn',
        globalField: 'Global (alle utstyrstyper)',
        assetTypeIds: 'Utstyrstyper',
      },
    },
  },
}
